import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '80vh' }}>
      <h1 style={{ fontSize: '72px', color: 'var(--secondary)' }}>404</h1>
      <h2 className="text-muted mb-2">Page Not Found</h2>
      <p className="text-muted mb-2">The page you are looking for does not exist or has been moved.</p>
      <Link to="/" className="btn btn-primary">Go to Dashboard</Link>
    </div>
  );
}